import { useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { authorizeSiteCredentialsService } from "@/services/AuthorizationService";
import { useAuthorizeQueryParams } from "../../hooks/site-credentials/useAuthorizeQueryParams";
import LoadingLogo from "@/components/loading-logo/loading-logo";

import { DigitalAsset } from "@/models/site-credentials/common/DigitalAsset";
import { DigitalAssetContext } from "../../contexts/site-credentials/DigitalAssetContext";
import { genericService } from "@/services/GenericService";
import { Config } from "@/config/Config";

export default function Authorization() {
  const history = useHistory();
  const authorizeQueryParams = useAuthorizeQueryParams();

  const digitalAssetContext = useContext(DigitalAssetContext);

  useEffect(() => {
    const authorize = async () => {
      const resp = await authorizeSiteCredentialsService.authorize({
        clientId: authorizeQueryParams.clientId || "",
        token: authorizeQueryParams.token || "",
        deeplinkAction: authorizeQueryParams.deeplinkAction || ""
      });

      if (resp.kind === "success") {
        const digitalAssetResult = await genericService.get<DigitalAsset>(
          `${Config.ContinenteCredentials.digitalAssetUrl}/${authorizeQueryParams.clientId}`
        );

        if (digitalAssetResult.kind === "success") {
          digitalAssetContext.updateDigitalAsset(
            digitalAssetResult.value as DigitalAsset
          );
        }

        history.push(resp.value.url,
          {
            nextStep: "/api" + resp.value.url,
            from: authorizeQueryParams.deeplinkAction ? "dl" : ""
          });
      }
    };

    authorize();
  }, [
    authorizeQueryParams.clientId,
    authorizeQueryParams.token,
    authorizeQueryParams.deeplinkAction,
    digitalAssetContext,
    history,
  ]);

  return (
    <>
      <LoadingLogo />
    </>
  );
}
